import { PAGE_SIZE } from "@faire/retailer-shared/search/searchRequest";
export var getPageSize = function(replacedProductTilesCount) {
    return PAGE_SIZE - replacedProductTilesCount;
};
export var getShouldWaitForBannersQuery = function(zeroIndexedPageNumber, isBannersQueryLoading) {
    return zeroIndexedPageNumber > 0 && isBannersQueryLoading;
};
var FROZEN_EMPTY_ARRAY = Object.freeze([]);
export function noOpReturningArrayOfType() {
    return FROZEN_EMPTY_ARRAY;
}
